import React from 'react';

import Carousel from 'nuka-carousel';

import blur from '../../assets/images/blur-homeview.png';
import homeviewLogos from '../../assets/images/homeviewLogos/homeviewLogos';

const PartnerCarousel = () => {
  const { logos } = homeviewLogos;
  return (
    <div className="homeView__partners">
      <img src={blur} className="homeBlur" alt="blur" />
      <Carousel
        className="homeView__carousel"
        autoplay
        slidesToShow={4}
        autoplayInterval={1000}
        wrapAround
        withoutControls
      >
        {logos.map((log, index) => (
          <img key={index} src={log} className="partnerLogo" alt="logo" />
        ))}
      </Carousel>
    </div>
  );
};

export default PartnerCarousel;
